//
import { ProductModel } from '@/models'

/**
 * 
 */
const remove = async ( id ) => {

    //
    try {

        //
        const product  = await ProductModel.find( id )
            , response = product.delete()

        //
        return response
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default remove
